var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('div',{staticClass:"container"},[_c('div',{staticClass:"text-title"},[_vm._v("System Requirements")]),_c('system-requirements-table',{staticClass:"q-mb-md",attrs:{"sysReq":_vm.sysReq,"bordered":true}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }